import { render, staticRenderFns } from "./ReportCertResult.vue?vue&type=template&id=d4b400f8&"
import script from "./ReportCertResult.vue?vue&type=script&lang=js&"
export * from "./ReportCertResult.vue?vue&type=script&lang=js&"
import style0 from "./ReportCertResult.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports